
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M36.0147 58.9767C52.1211 55.5531 62.3994 39.7243 58.9758 23.6189C55.5531 7.51431 39.7243 -2.76588 23.6189 0.657744C7.51431 4.08044 -2.76588 19.9092 0.657744 36.0147C1.67276 40.8264 3.86717 45.3107 7.04385 49.0645C7.70885 49.8499 8.88463 49.9475 9.67003 49.2825C10.4554 48.6175 10.553 47.4418 9.88802 46.6564C7.10904 43.3726 5.18957 39.4498 4.30216 35.2405C1.30614 21.1473 10.3007 7.29725 24.393 4.30216C38.4862 1.30614 52.3363 10.3007 55.3314 24.393C58.3274 38.4862 49.3328 52.3363 35.2396 55.3314C30.0657 56.4407 24.6763 55.9421 19.7937 53.9023C19.1793 53.6461 18.4749 53.737 17.9457 54.141C17.4166 54.5449 17.1431 55.2005 17.2284 55.8607C17.3136 56.5209 17.7446 57.0855 18.359 57.3418C23.9402 59.6731 30.1004 60.2435 36.0147 58.9767ZM30.4847 14.9112C35.6784 14.9112 39.13 18.8435 39.1328 22.5522C39.1328 24.9091 38.6558 26.586 37.3627 28.5032C36.5086 29.826 35.5607 30.746 34.6948 31.5865C33.1335 33.102 31.8384 34.3591 31.8384 37.2528H26.8636V35.7837C26.7705 32.9423 28.0756 30.6385 30.6263 28.8759L30.8788 28.6888C33.3263 26.8763 34.1469 26.2687 34.1469 23.6189C34.1469 20.6433 31.2803 19.83 29.3044 19.83C25.9954 19.83 24.4452 22.4134 24.4452 24.8542L19.5692 24.8365C19.5692 17.693 24.952 14.9112 30.4847 14.9112ZM31.789 39.7514V44.7224H26.8934V39.7514H31.789Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'QuestionCircle',
    }) as DefineComponent
    </script>
    